<header class="sticky-header" id="can-sticky">
  <!-- Header Menu  -->
  <div class="header-nav">
    <div class="container-fluid container-1600">
      <div
        class="nav-container"
        [ngClass]="visible ? '' : 'breakpoint-on'"
        (window:resize)="detectHeader()"
      >
        <!-- Site Logo -->
        <div class="site-logo">
          <a routerLink="/"
            ><img src="assets/img/logo_goody.png" alt="logo_goody"
          /></a>
        </div>

        <!-- Main Menu -->
        <div
          class="nav-menu d-lg-flex align-items-center"
          [ngClass]="navmethod ? '' : 'menu-on'"
        >
          <!-- Navbar Close Icon -->
          <div class="navbar-close">
            <div class="cross-wrap" (click)="toggleNav()">
              <span></span><span></span>
            </div>
          </div>

          <!-- Mneu Items -->
          <div class="menu-items">
            <ul>
              <li
                class="menu-item"
                [ngClass]="item.child == true ? 'has-submemu' : ''"
                *ngFor="let item of navigation"
              >
                <div *transloco="let t; read: 'menu'">
                  <a
                    href="javascript:void(0)"
                    (click)="trigger(item)"
                    *ngIf="item.child"
                    [ngClass]="item.link == router.url ? 'text-primary' : ''"
                    >{{
                      item.linkText == "Home"
                        ? t("menu_1")
                        : item.linkText == "Services"
                        ? t("menu_2")
                        : item.linkText == "Project"
                        ? t("menu_3")
                        : item.linkText == "Contact"
                        ? t("menu_4")
                        : ""
                    }}</a
                  >
                  <a
                    routerLink="{{ item.link }}"
                    [ngClass]="item.link == router.url ? 'text-primary' : ''"
                    *ngIf="!item.child"
                    >{{
                      item.linkText == "Home"
                        ? t("menu_1")
                        : item.linkText == "Services"
                        ? t("menu_2")
                        : item.linkText == "Project"
                        ? t("menu_3")
                        : item.linkText == "Contact"
                        ? t("menu_4")
                        : ""
                    }}</a
                  >
                </div>
                <!-- <ul
                  class="submenu"
                  *ngIf="item.child"
                  [ngClass]="item.open ? 'd-block' : ''"
                >
                  <li
                    class="menu-item"
                    [ngClass]="item.child == true ? 'has-submemu' : ''"
                    *ngFor="let item of item.submenu"
                  >
                    <a
                      href="javascript:void(0)"
                      (click)="trigger(item)"
                      *ngIf="item.child"
                      >{{ item.linkText }}</a
                    >
                    <a routerLink="{{ item.link }}" *ngIf="!item.child">{{
                      item.linkText
                    }}</a>
                    <ul
                      class="submenu"
                      *ngIf="item.child"
                      [ngClass]="item.open ? 'd-block' : ''"
                    >
                      <li class="menu-item" *ngFor="let item of item.submenu">
                        <a routerLink="{{ item.link }}">{{ item.linkText }}</a>
                      </li>
                    </ul>
                  </li>
                </ul> -->
              </li>
            </ul>
          </div>
          <!-- Pushed Item -->
          <div class="nav-pushed-item"></div>
        </div>

        <!-- Navbar Extra  -->
        <div class="navbar-extra d-lg-block d-flex align-items-center">
          <!-- Navbtn -->
          <div class="navbar-btn nav-push-item mx-5">
            <div class="menu-items">
              <ul>
                <li class="menu-item">
                  <a (click)="setLang()"
                    ><img  class="fi mx-2 mb-1"  height="20vh" [src]= " currentLang == 'en' ? 'assets/img/icons/th.png' : 'assets/img/icons/us.png' ">{{ currentLang == "en" ? "TH" : "EN" }}</a
                  >
                </li>
              </ul>
            </div>
            <!-- <a class="main-btn main-btn-3">A</a> -->
          </div>
          <!-- Navbar Toggler -->
          <div
            class="navbar-toggler"
            [ngClass]="navmethod ? '' : 'active'"
            (click)="toggleNav()"
          >
            <span></span><span></span><span></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
